module.exports = __webpack_public_path__ + "img/01-illu-matome2021.01c4391e.png";